import $ from 'jquery';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/sortable';

import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/themes/base/sortable.css';

import './legacy/vendor/facebox/facebox.css';
import './legacy/vendor/facebox/facebox';

import '../../source/javascripts/vendor/admin/js/libs/ui/i18n/ui.datepicker-ja';
import '../../source/javascripts/vendor/admin/js/libs/jquery.dateValidate';

import '../../source/javascripts/vendor/admin/js/libs/jquery.tablesorter.min';
import '../../source/javascripts/vendor/admin/js/libs/jquery.tablesorteskin/style.css';

import '../../source/javascripts/vendor/admin/vendor/tagInput/jquery.tagInput.css';
import '../../source/javascripts/vendor/admin/vendor/tagInput/jquery.tagInput';

import '../../source/stylesheets/vendor/jquery.dataTables.min.css';
import '../../source/javascripts/vendor/jquery.dataTables.min';

import '../../source/stylesheets/vendor/fullcalendar.css';
import '../../source/javascripts/vendor/fullcalendar.min';

import '../../source/javascripts/vendor/admin/js/libs/jquery.blockUI';

import './legacy/searchlist';

import './apps/csv_chart';
// import './apps/js-quick-patch';

import './legacy/qtip';

import openWindow from './utils/openWindowUtils';
import getNoCacheRandomString from './utils/URLUtiles';

import * as openWindowFunc from './apps/openWindowFunc';
import * as main from './legacy/main';

import facebox_loadingImage from './legacy/vendor/facebox/loading.gif';
import facebox_closeImage from './legacy/vendor/facebox/closelabel.gif';

window.openWindow = openWindow;
window.on_load = main.on_load;

window.getNoCacheRandomString = getNoCacheRandomString;

window.openFlashWindow = openWindowFunc.openFlashWindow;
window.openVcMyPortfolioWindow = openWindowFunc.openVcMyPortfolioWindow;
window.openPortfolioWindow = openWindowFunc.openPortfolioWindow;
window.openAddClassUserWindow = openWindowFunc.openAddClassUserWindow;
window.openAddClassUserForIdWindow = openWindowFunc.openAddClassUserForIdWindow;
window.openDeleteClassUserWindow = openWindowFunc.openDeleteClassUserWindow;
window.openEditSchrduleWindow = openWindowFunc.openEditSchrduleWindow;
window.info_release = openWindowFunc.info_release;
window.openSendMailWindow = openWindowFunc.openSendMailWindow;
window.openSendMailContractWindow = openWindowFunc.openSendMailContractWindow;
window.openMailUserSearchWindow = openWindowFunc.openMailUserSearchWindow;
window.openUserSearchWindow = openWindowFunc.openUserSearchWindow;
window.openUserSearchQuestWindow = openWindowFunc.openUserSearchQuestWindow;
window.openBookPreviewWindow = openWindowFunc.openBookPreviewWindow;
window.openContractBookPreviewWindow = openWindowFunc.openContractBookPreviewWindow;
window.openAssignPreviewWindow = openWindowFunc.openAssignPreviewWindow;
window.openSingleQuestionPreviewWindow = openWindowFunc.openSingleQuestionPreviewWindow;
window.openCombinationQuestionPreviewWindow = openWindowFunc.openCombinationQuestionPreviewWindow;
window.openQuestionPreviewWindow = openWindowFunc.openQuestionPreviewWindow;
window.openContractQuestionPreviewWindow = openWindowFunc.openContractQuestionPreviewWindow;
window.openWeeklyPreviewWindow = openWindowFunc.openWeeklyPreviewWindow;
window.openVCResultWindow = openWindowFunc.openVCResultWindow;
window.openVCMyPortfolioResultWindow = openWindowFunc.openVCMyPortfolioResultWindow;
window.openVCCorseworkWindow = openWindowFunc.openVCCorseworkWindow;
window.openVCListWindow = openWindowFunc.openVCListWindow;
window.openVCResetListWindow = openWindowFunc.openVCResetListWindow;
window.openCWDetailListWindow = openWindowFunc.openCWDetailListWindow;
window.openCWListWindow = openWindowFunc.openCWListWindow;
window.openCourseworkPreviewWindow = openWindowFunc.openCourseworkPreviewWindow;

window.openAuthoringQuestionPreviewWindow = openWindowFunc.openAuthoringQuestionPreviewWindow;
window.openCPQuestionPreviewWindow = openWindowFunc.openCPQuestionPreviewWindow;

window.passwd_init = main.passwd_init;
window.onLoadInfoList = main.onLoadInfoList;
window.list_search = main.list_search;
window.pageload = main.pageload;

window.getHashToArray = main.getHashToArray;
window.getCopyHash = main.getCopyHash;
window.getHashArrayValue = main.getHashArrayValue;
window.arrayChangeNameValue = main.arrayChangeNameValue;
window.reset_searchStrObject = main.reset_searchStrObject;
window.list_paging = main.list_paging;
window.list_sort = main.list_sort;
window.re_load = main.re_load;
window.search_form_dsp = main.search_form_dsp;
window.toggle_searchbox = main.toggle_searchbox;

window.hideNewsArea = main.hideNewsArea;
window.showNewsArea = main.showNewsArea;
window.onClickAddToCartButton = main.onClickAddToCartButton;

$(document).ready(() => {
  main.on_load('search_form', 'list/question_list.cfm');
  // TODO  jQueryUIを読み込んでいないので、エラーになるのでコメントアウト
  $('.sp_s_datepicker').datepicker({
    showButtonPanel: true,
  });

  $('a[rel*=facebox]').facebox({
    loadingImage: facebox_loadingImage,
    closeImage: facebox_closeImage,
  });
});



// WEBPACK FOOTER //
// ./es6/admin-common-js/app.js